var _path, _path2, _ellipse, _ellipse2, _ellipse3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyFilters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 112,
    fill: "none",
    viewBox: "0 0 100 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEF1F3",
    d: "M32.878 26.312s11.785 13.491 37.158-1.924C92.57 10.7 102.224 41.654 99.572 54.971c-3.435 17.252-25.316 27.097-18.433 40.32 6.883 13.222-24.531 26.204-36.017 6.966-14.288-23.931-22.68-8.626-33.204-10.804-7.552-1.563-19.17-23.51-5.805-35.285 11.247-9.908 7.25-14.796 5.766-19.345-2.14-6.56 9.137-20.831 20.999-10.51z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6BEC5",
    d: "M28 50.75v-5.874s9.824-2.937 20.588-2.937c10.765 0 20.589 2.937 20.589 2.937v5.873L54.47 71.395v20.47s-3.589-.264-6.618-1.732c-3.03-1.469-5.147-4.141-5.147-4.141V71.395L28 50.75z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.5,
    cy: 31.454,
    fill: "#C6CCD4",
    rx: 6.5,
    ry: 6.491
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.5,
    cy: 25.463,
    fill: "#C6CCD4",
    rx: 4.5,
    ry: 4.493
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.5,
    cy: 9.486,
    fill: "#C6CCD4",
    rx: 9.5,
    ry: 9.486
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFilters);
export default __webpack_public_path__ + "static/media/EmptyFilters.b8bf2bf7.svg";
export { ForwardRef as ReactComponent };